export default "__VITE_ASSET__zwfIIBeB__"